import { TimeStates, TimeWindow } from '@ui/interfaces'
import { create } from 'zustand'
import { combine, persist } from 'zustand/middleware'

const combineDefaults: TimeStates = {
  timewindow: { english: '5 min ago', relative: [5, 'minutes'] },
}

export const useTimeStore = create(
  persist(
    combine(combineDefaults, (set) => ({
      setTimewindow: (newTimeWindow: TimeWindow) => {
        set(() => {
          return { timewindow: newTimeWindow }
        })
      },
    })),
    {
      name: 'time-store',
    }
  )
)
